export default {"src":"/_next/static/media/ENA.09789d90.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};